const GRADIENT_STYLE = {
  backgroundImage:
    "linear-gradient(165deg, rgba(255, 118, 25, 0.08) 0%, transparent 55%)",
};

export default function GradientSummaryCard({ className = "", children }) {
  return (
    <section
      className={`rounded-2xl border border-hc-primary/25 p-6 ${className}`}
      style={GRADIENT_STYLE}
    >
      {children}
    </section>
  );
}
